import { BatchTypes } from '../../types/flowcode.types'

export const isStaticCodeType = (batchType?: string): boolean => {
  return batchType === BatchTypes.STATIC_CODE
}
